import { failedSourceRecords } from 'src/services/ConnectorDemo/data/failedSourceRecords';

export const getFailingTestDataById = (testId: string) => {
  return failedSourceRecords.find((test) => test.testId === testId);
};
